import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'rebass/styled-components';
import { HeaderSection } from './headerSection';
import { FieldsSection } from './fieldsSection';
import { SubmitButtonSection } from './submitButtonSection';
import { SuccessMessageSection } from './successMessageSection';

export const EditMode = ({
  formState,
  onUpdateHeader,
  onAddField,
  onUpdateField,
  onDeleteField,
  onReorderFields,
  onUpdateSubmitButton,
  onUpdateSuccessMessage,
  type,
  lastAddedFieldId,
  onClearLastAddedFieldId,
}) => {
  if (!formState) return null;

  return (
    <Flex
      sx={{
        flexDirection: 'column',
        gap: '32px',
        width: '100%',
        maxWidth: '520px',
        margin: '0 auto',
        py: '32px',
      }}
    >
      {type === 'form' && (
        <>
          <HeaderSection title={formState.title} description={formState.description} onUpdate={onUpdateHeader} />
          <FieldsSection
            fields={formState.fields}
            onAddField={onAddField}
            onUpdateField={onUpdateField}
            onDeleteField={onDeleteField}
            onReorderFields={onReorderFields}
            lastAddedFieldId={lastAddedFieldId}
            onClearLastAddedFieldId={onClearLastAddedFieldId}
          />
          <SubmitButtonSection buttonText={formState.submitButtonText} onUpdate={onUpdateSubmitButton} />
        </>
      )}
      {type === 'success' && (
        <SuccessMessageSection
          title={formState.successMessageTitle}
          description={formState.successMessageDescription}
          onUpdate={onUpdateSuccessMessage}
        />
      )}
    </Flex>
  );
};

EditMode.propTypes = {
  formState: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    fields: PropTypes.array.isRequired,
    submitButtonText: PropTypes.string.isRequired,
    successMessageTitle: PropTypes.string.isRequired,
    successMessageDescription: PropTypes.string.isRequired,
  }),
  onUpdateHeader: PropTypes.func.isRequired,
  onAddField: PropTypes.func.isRequired,
  onUpdateField: PropTypes.func.isRequired,
  onDeleteField: PropTypes.func.isRequired,
  onReorderFields: PropTypes.func.isRequired,
  onUpdateSubmitButton: PropTypes.func.isRequired,
  onUpdateSuccessMessage: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['form', 'success']),
  lastAddedFieldId: PropTypes.string,
  onClearLastAddedFieldId: PropTypes.func.isRequired,
};

EditMode.defaultProps = {
  formState: null,
  type: 'form',
  lastAddedFieldId: null,
};
